
import common from './modules/common'

const modules = {
  common,
}
export default modules
